/**
 * Redux action TYPE STRINGS for PIM. TypeScript shapes for those actions live in
 * `types/pim.action.interface.ts` — see redux-patterns.md on not overloading this filename.
 */
export const PIM_ACTION_TYPES = {
  SET_LOADING: 'PIM/SET_LOADING',
  SET_LOADING_ARCHIVED: 'PIM/SET_LOADING_ARCHIVED',
  SET_ERROR: 'PIM/SET_ERROR',
  SET_CHANNELS: 'PIM/SET_CHANNELS',
  SET_ARCHIVED_CHANNELS: 'PIM/SET_ARCHIVED_CHANNELS',
  UNARCHIVE_CHANNEL: 'PIM/UNARCHIVE_CHANNEL',
  ADD_CHANNEL: 'PIM/ADD_CHANNEL',
  UPDATE_CHANNEL: 'PIM/UPDATE_CHANNEL',
  REMOVE_CHANNEL: 'PIM/REMOVE_CHANNEL',
  SET_SETUPS: 'PIM/SET_SETUPS',
  ADD_SETUP: 'PIM/ADD_SETUP',
  UPDATE_SETUP: 'PIM/UPDATE_SETUP',
  REMOVE_SETUP: 'PIM/REMOVE_SETUP',
  SET_TABS: 'PIM/SET_TABS',
  SET_TABS_REQUEST_SCOPE: 'PIM/SET_TABS_REQUEST_SCOPE',
  ADD_TAB: 'PIM/ADD_TAB',
  UPDATE_TAB: 'PIM/UPDATE_TAB',
  REMOVE_TAB: 'PIM/REMOVE_TAB',
  SET_SUBTABS: 'PIM/SET_SUBTABS',
  SET_SUBTABS_REQUEST_SCOPE: 'PIM/SET_SUBTABS_REQUEST_SCOPE',
  ADD_SUBTAB: 'PIM/ADD_SUBTAB',
  UPDATE_SUBTAB: 'PIM/UPDATE_SUBTAB',
  REMOVE_SUBTAB: 'PIM/REMOVE_SUBTAB',
  SET_ACCORDION_SECTIONS: 'PIM/SET_ACCORDION_SECTIONS',
  SET_ACCORDION_SECTIONS_REQUEST_SCOPE: 'PIM/SET_ACCORDION_SECTIONS_REQUEST_SCOPE',
  ADD_ACCORDION_SECTION: 'PIM/ADD_ACCORDION_SECTION',
  UPDATE_ACCORDION_SECTION: 'PIM/UPDATE_ACCORDION_SECTION',
  REMOVE_ACCORDION_SECTION: 'PIM/REMOVE_ACCORDION_SECTION',
  SET_COLUMNS: 'PIM/SET_COLUMNS',
  SET_COLUMNS_REQUEST_SCOPE: 'PIM/SET_COLUMNS_REQUEST_SCOPE',
  SET_REQUIRED_COLUMNS_FOR_TAB: 'PIM/SET_REQUIRED_COLUMNS_FOR_TAB',
  SET_COLUMN_MAPPING_REGISTRY: 'PIM/SET_COLUMN_MAPPING_REGISTRY',
  SET_ALL_SETUP_COLUMNS: 'PIM/SET_ALL_SETUP_COLUMNS',
  ADD_COLUMN: 'PIM/ADD_COLUMN',
  UPDATE_COLUMN: 'PIM/UPDATE_COLUMN',
  REMOVE_COLUMN: 'PIM/REMOVE_COLUMN',
  SET_SELECTED_CHANNEL: 'PIM/SET_SELECTED_CHANNEL',
  SET_SELECTED_SETUP: 'PIM/SET_SELECTED_SETUP',
  SET_SELECTED_TAB: 'PIM/SET_SELECTED_TAB',
  SET_PUBLISH_FILTER: 'PIM/SET_PUBLISH_FILTER',
  SET_PRODUCT_ROWS: 'PIM/SET_PRODUCT_ROWS',
  SET_LOADING_ROWS: 'PIM/SET_LOADING_ROWS',
  UPDATE_ROW_CELL: 'PIM/UPDATE_ROW_CELL',
  SET_DOWNLOAD_LOGS: 'PIM/SET_DOWNLOAD_LOGS',
  APPEND_DOWNLOAD_LOGS: 'PIM/APPEND_DOWNLOAD_LOGS',
  SET_LOADING_DOWNLOAD_LOGS: 'PIM/SET_LOADING_DOWNLOAD_LOGS',
  DELETE_DOWNLOAD_LOG: 'PIM/DELETE_DOWNLOAD_LOG',
  CLEAR_PIM: 'PIM/CLEAR_PIM',
  SET_META_LIMITS: 'PIM/SET_META_LIMITS',
  SET_CHANNEL_SETUP_FILTERS: 'PIM/SET_CHANNEL_SETUP_FILTERS',
} as const;
